import { ComponentProps } from 'react';
import { Layout } from 'antd';
import styles from './MainContent.module.scss';

const { Content } = Layout;

type MainContentProps = ComponentProps<typeof Content> & {
  isTwoColumnsLayout: boolean;
};

const MainContent = ({
  className,
  isTwoColumnsLayout: _isTwoColumnsLayout,
  ...props
}: MainContentProps) => (
  <Content
    className={[styles.content, className].filter(Boolean).join(' ')}
    {...props}
  />
);

export default MainContent;
